import React from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
 
interface DialogDefaultProps {
    handleCancel: () => void;
    handleConfirm: () => void;
    open: boolean;
    displayText:string;
  }
  
  const DialogDefault: React.FC<DialogDefaultProps>  = ({ handleCancel, handleConfirm, open, displayText }) => {
 


  return (
    <>
      <Dialog
        size={"sm"}
        open={open}
        handler={()=>{}}
        placeholder=""
        onResize={() => {}}
        onResizeCapture={() => {}}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
        style={{ position: 'fixed', left: '35%',  top: '25%',transform: 'translateX(-50%)' , width: '30%', height: '15%', fontSize: 'small' }}
      >

        <DialogBody 
          style={{ paddingBottom: 0 }}
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >Are you sure want to confirm <b>{displayText}</b> ?</DialogBody>
        <DialogFooter 
          style={{ paddingTop: 0 }}
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          <Button
            variant="text"
            color="red"
            onClick={handleCancel}
            className="mr-1"
            placeholder=""
            onResize={() => {}}
            onResizeCapture={() => {}}
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          >
            <span>Cancel</span>
          </Button>
          <Button 
            variant="text" 
            color="green" 
            onClick={handleConfirm}
            placeholder=""
            onResize={() => {}}
            onResizeCapture={() => {}}
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          >
            <span>Confirm</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}

export default DialogDefault;
